import * as React from 'react'
import { ReactComponent as DefaultLogo } from '../../../assets/images/svg_icons/map_pins/selected-pin.svg'

function SvgComponent() {
  return <DefaultLogo />
}

export default SvgComponent
